import { getCustomers } from '../../../../crud/orgs.crud'

/**
 * Companies a system user can be given access to. The customers endpoint leaves out the organization's
 * own company, so it is added back when the viewer can access it.
 */
const getAssignableCustomers = async ({ hasAllCustomersAccess, allowedCustomers }) => {
  const { data } = await getCustomers('*', true)
  const { customers } = data
  if (hasAllCustomersAccess || allowedCustomers?.includes(data.id)) {
    customers.unshift({
      id: data.id,
      customer_name: data.customer_name,
      deactivated: data.deactivated,
      elastic_id: data.elastic_id,
      parent_id: data.parent_id,
      organization: data.organization,
      userCount: data.userCount,
    })
  }
  return customers
}

export default getAssignableCustomers
